import { FC } from "react";

interface ConditionalProps {
  if: boolean;
  children: React.JSX.Element;
}

const Conditional: FC<ConditionalProps> = (props): React.JSX.Element | null => {
  return !!props.if && props.children ? props.children : null;
};

export default Conditional;
